<template>

    
    <div class="card mb-2 mt-2">
        <div class="card-header">
            <h3>Search</h3>
        </div>
        <div class="card-body">
            <form>
                <div class="row">
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12"  v-for="(field,key) in searchField">

                        <template v-if="field.type=='checkbox' || field.type=='radio' || field.type=='select'">
                            <div class="form-group">
                                <label>{{field.label}}</label>
                                <v-select v-model="search[key]" :options="getFieldsArray(field.field_infos)"
                                    label="label" multiple>
                                    <template slot="no-options">No user
                                        available</template>
                                </v-select>
                            </div>
                        </template>

                        <template v-else-if="field.type=='daterange'">
                            <div class="form-group">
                            <label>{{field.label}}</label>
                                <div class="d-flex justifycontent-between aligin-items-center">
                                    <div>
                                    <label>FROM</label>
                                    <Datepicker :input-class="'form-control'" :calendar-button="true"
                                        :clear-button="true" :use-utc="false"
                                        :calendar-button-icon="'fa-solid fa-calendar-days'"
                                        :format="customFormatter" v-model="search[key + '__start']"></Datepicker>
                                    </div>
                                    <div>
                                    <label>TO</label>
                                    <Datepicker :input-class="'form-control'" :calendar-button="true"
                                        :clear-button="true" :use-utc="false"
                                        :calendar-button-icon="'fa-solid fa-calendar-days'"
                                        :format="customFormatter" v-model="search[key + '__end']"></Datepicker>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-else-if="field.type=='date'">
                            <div class="form-group">
                                <label>{{field.label}}</label>
                                <Datepicker :input-class="'form-control'" :calendar-button="true"
                                    :clear-button="true" :use-utc="false"
                                    :calendar-button-icon="'fa-solid fa-calendar-days'" :format="customFormatter"
                                    v-model="search[key + '__start']"></Datepicker>
                            </div>
                        </template>

                        <template v-else-if="field.type=='selectcomponent'">
                            <div class="form-group  item-select">
                                <label>{{field.label}}</label>
                                <input type="hidden" :id="field.id" v-model="search[key]">
                                <input type="text" class="form-control" :id="field.name" autocomplete="off"
                                    v-on:keyup="queryForKeywords($event, field.route,field.id)" />
                                <span class="group-select">
                                    <span ref="genericSearch"
                                        @click="openComponent(field.route,field.moduleName,field.id,field.name)"><i
                                            class="fa-solid fa-user-plus"></i></span>
                                    <span @click="clearComponent(search[key])"><i
                                            class="fa-solid fa-xmark"></i></span>
                                </span>
                            </div>
                        </template>

                        <template v-else>
                            <div class="form-group">
                                <label>{{field.label}}</label>
                                <input type="text" class="form-control" :id="key" v-model="search[key]">
                            </div>
                        </template>
                    </div>
                    

                    <!-- <template v-for="input in data">
                        <template v-if="input.basic_search == true">
                            <template v-for="field in input.basic_fields">

                                <template v-if="field.type=='text'">
                                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div class="form-group">
                                            <label :for="field.name">{{ field.label }}</label>
                                            <input type="text" class="form-control" v-bind:id="field.name"
                                                v-model.lazy="res[field.name]">
                                        </div>
                                    </div>
                                </template>

                                <template v-if="field.type=='selectbox'">
                                    <div :class="'col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12'">
                                        <div :class="'form-group'">
                                            <label :for="field.name">{{ field.label }}</label>
                                            <select class="form-select" v-bind:id="field.name"
                                                v-model.lazy="res[field.name]">
                                                <option v-for="item in field.items" :value="item" :key="item.id">
                                                    {{ item.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="field.type=='date'">
                                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div class="form-group">
                                            <label :for="field.name">{{ field.label }}</label>
                                            <Datepicker :id="field.name+'_start'"
                                                v-model.lazy="res[field.name+'_start']"
                                                :input-class="'form-control'" :calendar-button="true"
                                                :use-utc="false" :calendar-button-icon="'fa-solid fa-calendar-days'"
                                                :format="customFormatter" :clear-button="true"
                                                :clear-button-icon="'fa-solid fa-xmark'"></Datepicker>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <template v-for="field in input.basic_fields"> </template>
                        </template>

                    </template> -->



                </div>
            </form>
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-success btn-sm" type="button" @click="genericSearch('Search')">
                Search
            </button>
            <button class="btn btn-warning btn-sm" type="button" @click="genericSearch('Clear')">
                Cancel
            </button>
        </div>
    </div>
    

</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import vSelect from "vue-select";
    export default {
        name: "generic-search",
        components: {
            Datepicker,
            vSelect,
        },
        data() {
            return {
                labelText: true,
                editText: false,
                cancelText: false,
                newFilter: false,
                saveButton: false,
                searchButton: true,
                saveIcon: true,
                editIcon: true,
                searchField: [],
                search: {},
                dom_array: [],
                field_name: '',
                field_id: '',
                data: [],
                res: {},

            }
        },
        mounted() {
            this.dom_array = this.domArrayVariable;
        },
        methods: {
            loadGenericSearch(searchItem) {
                this.data = searchItem;
                this.searchField = searchItem.searchFieldsDef;
                //console.log(this.searchField);
            },

            customFormatter(date) {
                return moment(date).format('DD/MM/yyyy hh:mm:ss a');
            },
            genericSearch(type) {
                const self = this;

                let searchFieldDef = this.searchField;
                var searches = {};
                const searchDatas = Object.entries(this.search);
                for (const [key, value] of searchDatas) {
                    var newvalue = value;
                    if (Array.isArray(value)) {
                        newvalue = value.map((item) => item.key);
                    }
                    var mainKey = key;

                    const keyParts = key.split('__');

                    if (keyParts.length != 1) {
                        var [mainKey, subKey] = keyParts;
                    }

                    searches[key] = {
                        key: key,
                        value: newvalue,
                        field_info: searchFieldDef[key],
                        relationship: searchFieldDef[mainKey].relationship ?? '',
                    }
                }

                if (type == 'Search') {
                    self.$emit('searchEvent', searches)
                }
                if (type == 'Clear') {
                    self.res = {};
                    self.$emit('searchEvent', self.res)
                }
            },

            getFieldsArray(fielsinfo) {
                let fielsinfo2;
                if (typeof fielsinfo == 'string') {
                    fielsinfo2 = this.dom_array[fielsinfo];
                } else {
                    fielsinfo2 = fielsinfo;
                }

                const fielsinfo3 = Object.keys(fielsinfo2).map(key => {
                    return { key: key, label: fielsinfo2[key] };
                });
                return fielsinfo3
            },
            customFormatter(date) {
                return moment(date).format('DD/MM/yyyy');
            },
            openComponent(routeName, moduleName, field_id = null, field_name = null) {
                this.field_id = field_id;
                this.field_name = field_name;
                this.windowRef = window.open(`/popup?module=${routeName}&body=modal&callback=parentMethod&moduleName=${moduleName}`, "", "width=900,height=400,left=200,top=200");
                this.parentCompnent = routeName;
                this.windowRef.addEventListener('beforeunload', this.parentMethod);

            },
            parentMethod() {
                const module_name = this.parentCompnent.slice(0, -1);
                const parent_id = localStorage.getItem('parentid');
                const parent_name = localStorage.getItem('parentname');
                const parent_type = localStorage.getItem('parenttype');

                this.selectElement(module_name, parent_name, parent_id, parent_type);

                if (this.windowRef) {
                    this.windowRef.close();
                    this.windowRef = null;
                    this.$emit('close');
                }

                localStorage.removeItem('parentid');
                localStorage.removeItem('parentname');
                localStorage.removeItem('parenttype');

            },

            queryForKeywords(e, route, field_id = null) {
                const self = this;
                self.field_id = field_id;
                let searchData = e.target.value;
                let relatedModule = route + 's';
                self.showDropdown = false;

                if (searchData.length > 1) {
                    axios.post(`api/modules/searchItem`, { 'data': searchData, 'relatedModule': relatedModule }).then(function (response) {
                        self.dropdownList = response.data;
                        self.showDropdown = field_id;
                    });
                } else {
                    self.showDropdown = false;
                    self.dropdownList = [];

                    if (searchData.length == 0) {
                        self.selectElement(route, '', '', '');
                    }

                }
            },

            updateItem(id, name, type) {
                this.showDropdown = false;
                const module_name = type;
                this.selectElement(module_name, name, id, type);
            },
            clearComponent(modulesLink) {
                const self = this;
                self.dropdownList = [];
                if (self.dropdownList.length == 0) {
                    self.selectElement(modulesLink, '', '', '');
                }
            },
            selectElement(moduleName, name = null, id = null, module = null) {
                const p_name = this.field_name;
                const p_name_el = document.getElementById(p_name);
                p_name_el.value = name;
                p_name_el.dispatchEvent(new Event('input'));

                const p_id = this.field_id;
                const p_id_el = document.getElementById(p_id);
                p_id_el.value = id;
                p_id_el.dispatchEvent(new Event('input'));
            },
        }
    }
</script>